import React from "react";
import { Alert, Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { GameFeaturingPromoState } from "@/const";
import GameFeaturingPromoStateDisplay from "@components/Displays/GameFeaturingPromoStateDisplay";
import { DevForm } from "@components/Forms/Fields";
import { useSubmit } from "@components/Forms/Handlers";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { getEventSubmitter, url_reverse } from "@components/Utils";

function ListPromo({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:moderation:featuring:list", { kind: "promo" }));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("Игра")}</th>
                        <th>{t("Дата начала")}</th>
                        <th>{t("Дата окончания")}</th>
                        <th>{t("Статус")}</th>
                        <th>{t("Карман")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>
                                    <Link
                                        to={url_reverse("admin:moderation:featuring:edit", {
                                            kind: "promo",
                                            featuring_id: o.id,
                                        })}
                                    >
                                        {o.__model_locale_object.name}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={url_reverse("games:featuring:promo:list", { game_id: o.game_id })}>
                                        {o.game.base_locale_object.name}
                                    </Link>
                                </td>
                                <td>{o.date_start}</td>
                                <td>{o.date_stop}</td>
                                <td>
                                    <GameFeaturingPromoStateDisplay state={o.state} />
                                </td>
                                <td>
                                    {Object.keys(o.pocket_data).map((gl) => {
                                        return (
                                            <span key={`pocket_${o.id}_${gl}`}>
                                                <a
                                                    href={url_reverse("pocket:item:edit", {
                                                        slug: `play2-promo`,
                                                        item_id: o.pocket_data[gl],
                                                    })}
                                                    target="_blank"
                                                >
                                                    {gl}
                                                </a>{" "}
                                            </span>
                                        );
                                    })}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function EditPromo({ id }) {
    const kind = "promo";
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(url_reverse("api:moderation:featuring:edit", { kind, featuring_id: id }));
    const onFormSubmit = useSubmit();
    const navigate = useNavigate();

    if (!apiData) return;

    const handleSubmit = (ev) => {
        const { tv } = getEventSubmitter(ev);
        const newApiData = { ...apiData };
        if (tv === "approve") {
            newApiData.forms_data.main.data.state = GameFeaturingPromoState.APPROVED;
        } else if (tv === "reject") {
            newApiData.forms_data.main.data.state = GameFeaturingPromoState.REJECTED;
        }
        setApiData(newApiData);
        onFormSubmit(ev, {
            onOK: (resp) => {
                setApiData(resp);
                if (resp.object.state === GameFeaturingPromoState.APPROVED) {
                    for (const [, item_id] of Object.entries(resp.object.pocket_data)) {
                        window.open(url_reverse("pocket:item:edit", { slug: `play2-promo`, item_id }));
                    }
                }
                navigate(url_reverse("admin:moderation:featuring:list", { kind }));
            },
        });
    };

    const { game } = apiData;
    const header = game && (
        <>
            <Link to={url_reverse("admin:moderation:featuring:list", { kind })}>{t("Промоматериалы")}</Link> -{" "}
            <Link to={url_reverse("games:admin", { game_id: game.id })}>{game.__model_locale_object.name}</Link>
        </>
    );

    return (
        <CommonCard header={header}>
            {Object.keys(apiData.forms_data || {}).map((prefix, i) => {
                if (prefix === "main") {
                    return null;
                }
                return (
                    <div key={i}>
                        <Alert variant="secondary">{prefix}</Alert>
                        <RenderForm prefix={prefix} bareForm={true} />
                    </div>
                );
            })}

            <hr />

            <Form onSubmit={handleSubmit}>
                <RenderForm bareForm={true} />
                {[GameFeaturingPromoState.MODERATE, GameFeaturingPromoState.POSTMODERATE].includes(
                    apiData.object?.state
                ) && (
                    <>
                        <DevForm.Button variant="success" type="submit" name="action" value="approve">
                            {t("Одобрить")}
                        </DevForm.Button>{" "}
                        <DevForm.Button variant="danger" type="submit" name="action" value="reject">
                            {t("Отклонить")}
                        </DevForm.Button>
                    </>
                )}
            </Form>
        </CommonCard>
    );
}

export default function FeaturingModerationScreen() {
    const { t } = useTranslation();
    const header = t("Промоматериалы");
    const params = useParams();

    return <DefaultLayout>{params?.id ? <EditPromo id={params.id} /> : <ListPromo header={header} />}</DefaultLayout>;
}
